import { render, staticRenderFns } from "./CheckboxSmsMarketing.vue?vue&type=template&id=28dca0ed&"
import script from "./CheckboxSmsMarketing.vue?vue&type=script&lang=js&"
export * from "./CheckboxSmsMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports